module.exports = __webpack_public_path__ + "static/media/cola-cover.2b6df68a.jpg";